module.exports = __webpack_public_path__ + "static/media/AwsDoc9.e5894571.png";